// Guarda el evento `beforeinstallprompt` a nivel de módulo. Chrome lo dispara
// una sola vez al cargar la página (a veces antes de que React monte la UI), así
// que escucharlo dentro de un componente lo pierde, por ejemplo si el usuario
// ya tiene sesión y no pasa por el login, o tras desinstalar la app.
let deferredPrompt = null;
const listeners = new Set();

const notify = () => listeners.forEach((listener) => listener(deferredPrompt));

export function captureInstallPrompt() {
  window.addEventListener("beforeinstallprompt", (event) => {
    event.preventDefault();
    deferredPrompt = event;
    notify();
  });
  window.addEventListener("appinstalled", () => {
    deferredPrompt = null;
    notify();
  });
}

export const getDeferredPrompt = () => deferredPrompt;

export const clearDeferredPrompt = () => {
  deferredPrompt = null;
  notify();
};

export function subscribeInstallPrompt(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}
